import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Globals } from '../../global/globals';
import { ExtractionQuestion } from '../domain/extraction-question.model';
import { QuestionnairePort } from '../ports/questionnaire.port';

/**
 * Concrete HTTP REST Adapter implementing the QuestionnairePort.
 * Translates application needs into backend HTTP GET and POST calls.
 */
@Injectable({
  providedIn: 'root',
})
export class HttpQuestionnaireAdapter implements QuestionnairePort {
  constructor(
    private httpClient: HttpClient,
    private globals: Globals,
  ) {}

  private getBaseUri(projectId: string | number): string {
    return `${this.globals.backendUri}/projects/${projectId}/extraction-questions`;
  }

  getQuestions(projectId: string | number): Observable<ExtractionQuestion[]> {
    return this.httpClient.get<ExtractionQuestion[]>(this.getBaseUri(projectId));
  }

  saveQuestions(
    projectId: string | number,
    questions: ExtractionQuestion[],
  ): Observable<ExtractionQuestion[]> {
    return this.httpClient.post<ExtractionQuestion[]>(this.getBaseUri(projectId), questions);
  }
}
